import { useTLang } from 'intl/intl';

export function useCBBannerLang() {
  return {
    description: useTLang({ id: 'browser.banner.extension.description' }),
    cta: useTLang({ id: 'browser.banner.extension.cta' }),
  };
}
